import { Component, TemplateRef } from '@angular/core';
import { AppBrandingService } from '@eucoms/common-components';

import { IPayload } from '@app/core/interfaces/payload.interface';
import { FallbackReportService } from '@app/fallback-report/local-service/fallback-report.service';

export type TabLabel = TextTabLabel | TemplateTabLabel;
export interface TextTabLabel extends IPayload {
  text: string;
}
export interface TemplateTabLabel extends IPayload {
  template: TemplateRef<any>;
}

/** renders the tabbed navigation for different sets of data to render (by county, etc) */
@Component({
  selector: 'app-fallback-table-nav',
  templateUrl: './table-nav.component.html',
  styleUrls: ['./table-nav.component.scss']
})
export class TableNavComponent {
  get opCoColor () {
    return this.appBranding.theme['--primaryBrand'];
  }

  get tabs(): Array<TabLabel> {
    return this.localService.tabs;
  }

  constructor(
    private appBranding: AppBrandingService,
    private localService: FallbackReportService
  ) {}

  onClickTab(tab: TabLabel) {
    // console.log('onClickTab', tab);
    if (!tab.payload) {
      tab.payload = {};
    }

    const isChange = !tab.payload.isSelected;
    tab.payload.isSelected = true;
    if (isChange) {
      this.localService.selectTabSubject.next(tab);
    }
  }
}
